import { useState } from "react";

export default function useFlipBook() {
  const [page, setPage] = useState(1);
  const [isFlipping, setIsFlipping] = useState(false);

  const handleFlipping = () => {
    setIsFlipping(true);

    setTimeout(() => {
      setIsFlipping(false);
    }, 800);
  };

  const prevImg = () => {
    setPage(1);
    handleFlipping();
  };

  const nextImg = () => {
    setPage(2);
    handleFlipping();
  };

  const rotateY = page === 1 ? 0 : -180;

  return { page, isFlipping, prevImg, nextImg, rotateY };
}
